/* Copyright Epic Games, Inc. All Rights Reserved. */

import { applyNegotiationStrategy } from "./negotiation-strategy";

/**
 * Wrapper to ensure our negotation strategy gets standard locale formats.
 */
export function getSupportedLocale<T extends string>(
  requested: string,
  supported: T[],
  defaultLocale: T
): T {
  try {
    const canonicalLocale = Intl.getCanonicalLocales(requested);
    const firstCanonicalLocale = canonicalLocale[0];

    const locale = applyNegotiationStrategy(
      firstCanonicalLocale,
      supported,
      defaultLocale
    );

    return locale;
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(`Invalid locale requested, "${requested}".
Returning default: "${defaultLocale}"`);
    return defaultLocale;
  }
}
